import React from "react";
import { connect } from "react-redux";
import LookMainWizardSelectedStep from "./lookMainWizardSelectedStep";
import {getCurrentGroups} from "./lookWizard/lookWizardFunctions";
import {WIZARD_STEP_MOBILE_WIDTH, WIZARD_STEP_WIDTH} from "../../core/constants";


const LookMainWizardSelectedSteps = (props) => {

  const {wizardActiveItem, wizardSelectedValues, wizardActiveStep, windowWidth, isMobile, fabricatorData} = props;

  if (!wizardActiveItem || !wizardSelectedValues || !Object.keys(wizardSelectedValues).length) {
    return null
  }

  const stepWidth = isMobile ? WIZARD_STEP_MOBILE_WIDTH : WIZARD_STEP_WIDTH;

  const styles = {
    width: Object.keys(wizardSelectedValues).filter(key => key < wizardActiveStep).length * stepWidth
  }

  const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
  const isCompletedStep = wizardActiveStep > -1 && !currentGroups.length;
  const menuWidth = isMobile
    ? windowWidth - 384
    : windowWidth - (isCompletedStep ? 408 : 728)
  const useContainerOverFlow = styles.width > menuWidth;

  return (
    <div className={"lw-steps" + (isCompletedStep && !isMobile ? " lw-steps--finished" : "")
      + (fabricatorData.isEncore && !isMobile ? " lw-steps--no--thumbnails" : "")
      + (useContainerOverFlow ? " lw-steps--scrollable" : "")} style={styles}>
      <ul className="lw-steps__list">
        {Object.keys(wizardSelectedValues).reverse().map((key) => {
          return <LookMainWizardSelectedStep wizardSelectedValue={wizardSelectedValues[key]}
                                             stepIndex={+key}
                                             key={"wizValue" + key}/>
        })}
      </ul>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardSelectedValues, wizardActiveStep} = store.wizardState;
  const {windowWidth, isMobile} = store.serverState;
  const fabricatorData = store.fabricatorState;

  return {
    wizardActiveItem,
    wizardSelectedValues,
    wizardActiveStep,
    windowWidth,
    isMobile,
    fabricatorData,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LookMainWizardSelectedSteps)
